export { default } from './isImmutableSet'
